<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col cols="7">
        <div class="darker">{{ text }}</div>
      </v-col>
      <v-col cols="2" class="text-center">
        <span></span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PlaceholderScheduleMatch",
  components: {},
  props: {
    uid: {
      type: String,
      required: true,
    },
    game: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.darker {
  color: #aaa;
}
</style>
